<template>
  <v-container fluid>
    <v-layout>
      <v-flex xl4 offset-xl4 md6 offset-md3 sm10 offset-sm1 xs12 offset-xs0>
        <v-progress-linear v-if="isSubmitting" :indeterminate="true"></v-progress-linear>
        <notifications group="invoices" key="invoices" />

        <v-card>
          <v-card-text>
            <v-list two-line subheader v-if="invoices.length">
              <div v-for="(data, i) in invoices" :key="data.year">
                <v-subheader inset>{{ data.year }}</v-subheader>

                <v-list-tile
                  v-for="invoice in data.invoices"
                  :key="invoice.invoiceNo"
                  avatar
                  :href="getDownloadLink(invoice)"
                  target="_blank"
                >
                  <v-list-tile-avatar>
                    <v-icon>attachment</v-icon>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title>
                      <v-layout>
                        <v-flex xs6>
                          Faktura {{ invoice.invoiceNo }}
                        </v-flex>
                        <v-flex xs6>
                          {{ invoice.sumWithVAT | formatCurrency }}
                        </v-flex>
                      </v-layout>
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      {{ invoice.postedDate }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-icon v-if="invoice.isPayed || invoice.isCreditMemo" color="green darken-3">check_circle</v-icon>
                    <v-subheader v-else style="text-align: right; color: #aa2222;">
                      {{ invoice.dueDate }}
                    </v-subheader>
                  </v-list-tile-action>
                </v-list-tile>

                <v-divider v-if="i < invoices.length - 1"></v-divider>
              </div>
            </v-list>
            <div v-else>
              Du har ingen fakturaer enda.
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import config from '@/config'
import InvoiceService from '@/services/InvoiceService'

export default {
  name: 'invoices',
  mounted () {
    this.init()
  },
  data () {
    return {
      isSubmitting: false,
      invoices: []
    }
  },
  methods: {
    async init () {
      this.invoices = []

      const response = await this.runService(this, 'invoices', InvoiceService.getList)
      if (response) {
        const byYear = {}
        response.data.forEach(invoice => {
          byYear[invoice.year] = byYear[invoice.year] || []
          byYear[invoice.year].push(invoice)
        })

        for (let year in byYear) {
          byYear[year].sort(x => -x.invoiceNo)
          this.invoices.push({
            year,
            invoices: byYear[year]
          })
        }

        this.invoices.sort(x => x.year)
      }
    },
    getDownloadLink (invoice) {
      return config.API_URL + 'invoices/' + invoice.invoiceNo + '/download' + '?token=' + this.$store.state.token + '&customer=' + this.$store.state.customer.customerNumber
    }
  }
}
</script>
